var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.route)?_c('BaseLink',{attrs:{"tag":"li","to":_vm.route}},[_c('a',{style:(_vm.colors)},[_vm._v(_vm._s(_vm.getRouteTitle(_vm.route)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }